'use client'

import { createContext, useContext, useMemo, useState } from 'react'
import { IChildrenProps } from '@/typings/children-props'

interface ICitiesFinderContext {
    hoveredCitySlug: string | null
    setHoveredCitySlug: (slug: string | null) => void
}

const CitiesFinderContext = createContext<ICitiesFinderContext>({
    hoveredCitySlug: null,
    setHoveredCitySlug: () => {},
})

export const CitiesFinderContextProvider = ({ children }: IChildrenProps) => {
    const [hoveredCitySlug, setHoveredCitySlug] = useState<string | null>(null)

    return (
        <CitiesFinderContext.Provider
            value={useMemo(
                () => ({
                    hoveredCitySlug,
                    setHoveredCitySlug,
                }),
                [hoveredCitySlug]
            )}
        >
            {children}
        </CitiesFinderContext.Provider>
    )
}

export const useCitiesFinderContext = () => useContext(CitiesFinderContext)
